import apiConfig from "../../apiConfig";

export const deleteDonationBand = async (at, donationBandId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/DONATIONS_BANDS/Delete_Donation_Band",
		{
			Donation_Band_Id: donationBandId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	// if (response.data.Status) {
	// 	return response.data;
	// }

	// return [];
	return response.data;
};
